import { useMemo } from "react";
import { useSelector } from "react-redux";

import { getFeatureSymbol } from "../../../evergis/core/symbol/getFeatureSymbol";
import { usePostgresLayer } from "../../../hooks/layer/usePostgresLayer";
import { useCurrentLayerName } from "../../../hooks/layer/useCurrentLayer";
import { useCurrentLayerStyleProxy } from "../../Style/hooks/useCurrentLayerStyle";
import { isLocationStyleSelector } from "../../../ducks/location/selectors";
import { FeatureAttribute } from "../components/Attributes/FeatureAttributeField";
import { StyleSymbolType } from "../../../interfaces/style";

export const useFeatureSymbol = (featureLayer: string, attributes: FeatureAttribute[]): StyleSymbolType | null => {
  const { postgresLayer } = usePostgresLayer(featureLayer, { waitInput: true });
  const currentLayerName = useCurrentLayerName();
  const currentStyle = useCurrentLayerStyleProxy();
  const isStyleLocation = useSelector(isLocationStyleSelector);

  const featureStyle =
    isStyleLocation && featureLayer && currentLayerName === featureLayer ? currentStyle : postgresLayer.style;

  return useMemo(() => getFeatureSymbol(featureStyle, attributes), [attributes, featureStyle]);
};
